import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

export function Header() {
  const { user, isAuthenticated, signOut } = useAuthStore();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <header className="bg-white shadow-sm relative">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" onClick={closeMenu}>
          <CraneLogo className="w-8 h-8" />
          <span className="text-xl font-bold text-primary">CloudFruit Hunts</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-text-light hover:text-primary font-medium">
            Hunts
          </Link>
          <Link to="/rules" className="text-text-light hover:text-primary font-medium">
            Rules
          </Link>

          {isAuthenticated ? (
            <div className="flex items-center gap-4">
              {user?.isAdmin && (
                <Link to="/admin" className="text-sm text-secondary hover:text-primary font-medium">
                  Admin
                </Link>
              )}
              <Link to="/profile" className="text-sm text-text-light hover:text-primary font-medium">
                {user?.email?.split('@')[0]}
              </Link>
              <button
                onClick={signOut}
                className="text-sm text-accent hover:text-primary font-medium"
              >
                Sign Out
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/login" className="btn-outline text-sm py-2 px-4">
                Log In
              </Link>
              <Link to="/signup" className="btn-primary text-sm py-2 px-4">
                Sign Up
              </Link>
            </div>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 text-text-dark"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 z-50">
          <div className="px-4 py-4 space-y-4">
            <Link
              to="/"
              className="block text-text-dark hover:text-primary font-medium py-2"
              onClick={closeMenu}
            >
              Hunts
            </Link>
            <Link
              to="/rules"
              className="block text-text-dark hover:text-primary font-medium py-2"
              onClick={closeMenu}
            >
              Rules
            </Link>

            {isAuthenticated ? (
              <>
                <Link
                  to="/profile"
                  className="block text-text-dark hover:text-primary font-medium py-2"
                  onClick={closeMenu}
                >
                  My Profile
                </Link>
                {user?.isAdmin && (
                  <Link
                    to="/admin"
                    className="block text-secondary hover:text-primary font-medium py-2"
                    onClick={closeMenu}
                  >
                    Admin
                  </Link>
                )}
                <button
                  onClick={() => {
                    signOut();
                    closeMenu();
                  }}
                  className="block w-full text-left text-accent hover:text-primary font-medium py-2"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <div className="space-y-3 pt-2 border-t border-gray-100">
                <Link
                  to="/login"
                  className="block btn-outline text-center py-3"
                  onClick={closeMenu}
                >
                  Log In
                </Link>
                <Link
                  to="/signup"
                  className="block btn-primary text-center py-3"
                  onClick={closeMenu}
                >
                  Sign Up
                </Link>
              </div>
            )}
          </div>
        </nav>
      )}
    </header>
  );
}

function CraneLogo({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 4L4 16L16 28L28 16L16 4Z"
        fill="#f6f3ef"
        stroke="#2e348d"
        strokeWidth="2"
      />
      <path
        d="M16 8L8 16L16 24L24 16L16 8Z"
        fill="#329f81"
        opacity="0.3"
      />
      <circle cx="14" cy="14" r="1.5" fill="#2e348d" />
      <path
        d="M16 16L20 12"
        stroke="#b00378"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
